import React from "react";
import PropTypes from "prop-types";
import { FiArrowRight, FiAward, FiClock } from "react-icons/fi";
import { useTranslation } from "react-i18next";

/** One survey opportunity: reward, duration and a single primary action. */
const SurveyCard = ({ minutes, points, surveyName, ShowPopup, surveyData }) => {
  const { t } = useTranslation();
  return (
    <article className="flex flex-col h-full p-4 zs-card zs-card-interactive sm:p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center min-w-0 gap-3">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg shrink-0 bg-primary-soft text-primary-text">
            <FiAward className="w-5 h-5" aria-hidden="true" />
          </span>
          <div className="min-w-0">
            <div className="text-2xl font-bold leading-none tracking-tight font-display tabular-nums text-ink">
              {points}
            </div>
            <div className="mt-1 text-xs font-medium text-ink-3">{t("referFriend.Points")}</div>
          </div>
        </div>
        <span className="zs-badge shrink-0 tabular-nums">
          <FiClock className="w-3.5 h-3.5" aria-hidden="true" />
          {minutes} {t("survey.card.Min")}
        </span>
      </div>

      <div className="flex-1 pt-4 mt-4 border-t border-line">
        <p className="text-[11px] font-semibold tracking-wider uppercase text-ink-4">{t("survey.card.Name")}</p>
        <p
          className="mt-1 text-sm font-medium leading-snug break-words text-ink"
          title={surveyName}
          style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}
        >
          {surveyName}
        </p>
      </div>

      <button className="mt-5 zs-btn zs-btn-primary zs-btn-block" onClick={() => ShowPopup(surveyData)}>
        {t("survey.card.Attempt")}
        <FiArrowRight aria-hidden="true" />
      </button>
    </article>
  );
};

SurveyCard.propTypes = {
  minutes: PropTypes.number.isRequired,
  points: PropTypes.number.isRequired,
  surveyName: PropTypes.string.isRequired,
  attemptFunction: PropTypes.func.isRequired,
  surveyData: PropTypes.object.isRequired,
  ShowPopup: PropTypes.func.isRequired,
};

export default SurveyCard;
